import React from 'react'
import avatar from '../_images/avatar.png'
import { capitalize, truncate } from '../_utils'

export default function AvatarProfile( { label, expand = false } ) {
  return (
    <div className="flex flex-row items-center justify-center">
      <div className={`rounded-full w-8 h-8 overflow-hidden border border-gray-200`}>
        <img src={avatar} alt="Profile Image" className="object-contain" />
      </div>
      <div className="flex flex-col items-start justify-center">
        <span className="text-gray-500 mx-2 text-xs">
           {label}
        </span>
      </div>
    </div>
  )
}
